import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiDiscovery = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.4336 3.16798C16.9655 1.61059 19.0322 1.61059 19.5664 3.16798L22.0635 10.4805C22.5705 11.9586 23.6631 13.1246 25.0488 13.6631L31.9043 16.3291C33.3646 16.8988 33.3646 19.1036 31.9043 19.6709L25.0488 22.334C23.6631 22.8749 22.5705 24.0413 22.0635 25.5195L19.5664 32.832L19.5117 32.9736C18.9257 34.3421 17.0743 34.3421 16.4883 32.9736L16.4336 32.832L13.9365 25.5195C13.4295 24.0413 12.337 22.8749 10.9512 22.334L4.09571 19.6709C2.63541 19.1036 2.63541 16.8988 4.09571 16.3291L10.9512 13.6631C12.3369 13.1246 13.4295 11.9587 13.9365 10.4805L16.4336 3.16798ZM16.9649 11.5147L16.9639 11.5186C16.1693 13.8351 14.4255 15.7467 12.1094 16.6465L12.1084 16.6455L8.62892 17.999L12.1094 19.3516L12.1143 19.3535C14.2818 20.1995 15.949 21.9296 16.8037 24.0518L16.9639 24.4815L16.9649 24.4854L18 27.5166L19.0352 24.4854L19.0361 24.4815C19.8308 22.1644 21.574 20.2558 23.8858 19.3535L23.8906 19.3516L27.3701 17.999L23.8906 16.6455C21.5743 15.7456 19.8306 13.8349 19.0361 11.5186L19.0352 11.5147L18 8.48244L16.9649 11.5147Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAiDiscovery);
export { ForwardRef as ReactComponent };
